"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var utilities_1 = require("@fluentui/utilities");
var Calendar_base_1 = require("./Calendar.base");
var Calendar_styles_1 = require("./Calendar.styles");
exports.Calendar = utilities_1.styled(Calendar_base_1.CalendarBase, Calendar_styles_1.styles, undefined, {
    scope: 'Calendar',
});
//# sourceMappingURL=Calendar.js.map